import {takeEvery} from 'redux-saga';
import {call, put} from 'redux-saga/effects'; // eslint-disable-line
import {appError, busy, ready} from './Status'; // eslint-disable-line
import {searchLink} from './Navigation';

export const CHANGE_KEYWORD = 'app-qa/search/CHANGE_KEYWORD';
export const changeKeyword = (q = '') => ({type: CHANGE_KEYWORD, q});

export const SEARCH_QUESTIONS = 'app-qa/search/SEARCH_QUESTIONS';
export const searchQuestions = (q = '', offset = 0, contextType, limit = 20, order = 'relevance', append = false) =>
  ({type: SEARCH_QUESTIONS, q, limit, offset, order, append, contextType});

export const SEARCH_QUESTIONS_SUCCESS = 'app-qa/search/SEARCH_QUESTIONS_SUCCESS';
export const searchQuestionsSuccess = (results, append, total, limit, offset) => ({type: SEARCH_QUESTIONS_SUCCESS, results, append, total, limit, offset});

export const SET_LOADING_QUESTIONS = 'app-qa/search/SET_LOADING_QUESTIONS';


export const actions = {
  SEARCH_QUESTIONS,
  CHANGE_KEYWORD,
};

const initialState = {
  q: '',
  results: [],
  loading: false,
  total: 0,
  limit: 20,
  offset: 0,
  order: '',
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SEARCH_QUESTIONS:
      return {...state, loading: true, q: action.q, contextType: action.contextType};
    case SEARCH_QUESTIONS_SUCCESS: {
      const {results, append, total, limit, offset, contextType} = action;
      return {
        ...state,
        results: append ? state.results.concat(results) : results,
        limit,
        offset,
        total,
        contextType,
      };
    }
    case CHANGE_KEYWORD:
      return {...state, q: action.q, contextType: action.contextType};
    default:
      return state;
  }
}

export function sagas({qaClient, history}) { // eslint-disable-line
  function *searchQuestionsSaga({ q, offset, contextType }) { // eslint-disable-line
    // its a hack - we should dispatch router.location somehow
    if (history && offset === 0) {
      history.push(searchLink(q));
    }
    yield put(busy({blockUi: true}));
    const searchResult = yield call(() => qaClient.search(q, contextType, offset));
    const {result: results, total, limit} = searchResult;
    yield put(searchQuestionsSuccess(results, offset > 0, total, limit, offset));
    yield put(ready());
  }

  return {
    *watchSearchQuestions() { yield* takeEvery(SEARCH_QUESTIONS, searchQuestionsSaga); },
  };
}
